// src/StartBuildingSection.jsx (or your components directory)
import React from "react";

const StartBuildingSection = () => {
  // Define custom colors for better accuracy if needed
  const bgColor = "#073214"; // Updated dark green color
  const mountainColor1 = "rgba(165, 102, 52, 0.4)"; // Darker, more transparent brown/orange
  const mountainColor2 = "rgba(210, 130, 67, 0.5)"; // Lighter, slightly less transparent brown/orange

  // No need for separate color consts here if we hardcode
  // const newOrange = "#E55812";
  // const newOrangeHover = "#D0500E"; // A slightly darker version for hover

  return (
    // Added font-poppins to the outer section
    <section className="py-16 lg:py-24 bg-gray-50 font-poppins">
      {" "}
      {/* Outer section background */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div
          style={{ backgroundColor: bgColor }} // bgColor variable is now #073214
          className="relative rounded-2xl shadow-xl overflow-hidden text-white px-6 py-16 md:px-12 md:py-20 lg:px-24 lg:py-28 text-center"
        >
          {/* Decorative Mountain Shapes - CSS Approximation */}
          {/* Layer 1 (further back, darker) */}
          <div
            className="absolute bottom-0 left-0 w-full h-2/5 md:h-1/2 opacity-80"
            style={{
              clipPath:
                "polygon(0 60%, 25% 40%, 50% 70%, 75% 30%, 100% 80%, 100% 100%, 0% 100%)",
              background: `linear-gradient(to top, ${mountainColor1}, transparent)`,
              zIndex: 1,
            }}
          ></div>
          {/* Layer 2 (closer, lighter) */}
          <div
            className="absolute bottom-0 left-0 w-full h-1/3 md:h-2/5 opacity-90"
            style={{
              clipPath:
                "polygon(0 75%, 30% 60%, 60% 80%, 85% 50%, 100% 70%, 100% 100%, 0% 100%)",
              background: `linear-gradient(to top, ${mountainColor2}, transparent)`,
              zIndex: 2,
            }}
          ></div>

          {/* Content - ensure it's above the decorative shapes */}
          <div className="relative z-10">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
              Discover the Career Paths that match your skills
            </h2>
            <p className="text-gray-300 text-base md:text-lg max-w-xl mx-auto mb-10">
              Ready to take the next step in your career? Sign up to identify
              in-demand and high-paying career paths that match your skills and
              get matched with the perfect job opportunities in minutes.
            </p>
            <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-4">
              <a
                href="/signup" // Replace with your actual link
                className="bg-[#E55812] hover:bg-[#D0500E] text-white font-semibold py-3 px-8 rounded-full transition-colors text-sm md:text-base w-full sm:w-auto"
              >
                Create Account
              </a>
              {/* <a
                href="#try-now" // Replace with your actual link
                className="bg-white hover:bg-gray-100 text-[#E55812] font-semibold py-3 px-8 rounded-full transition-colors text-sm md:text-base w-full sm:w-auto"
              >
                Try Now
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StartBuildingSection;
